import React from "react";

function SpeakSeveralLanguagesIcon() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="57"
            height="57"
            fill="none"
            viewBox="0 0 57 57"
        >
            <rect width="57" height="57" fill="#EF4F80" rx="10"></rect>
            <path
                fill="#fff"
                d="M28.5 45c-1.938 0-3.956-2.662-5.157-7.1a35.45 35.45 0 0110.314 0c-1.2 4.438-3.22 7.1-5.157 7.1zm0-8.972a36.322 36.322 0 00-5.505.413 35.636 35.636 0 01-.725-6.693h12.46a35.636 35.636 0 01-.725 6.693 36.322 36.322 0 00-5.505-.413zM13 29.748h7.82c.03 2.336.284 4.664.754 6.95a22.61 22.61 0 00-5.54 1.794A16.222 16.222 0 0113 29.748zm3.034-10.264a22.61 22.61 0 005.54 1.794 36.96 36.96 0 00-.754 6.95H13a16.222 16.222 0 013.034-8.744zM28.5 13c1.938 0 3.956 2.662 5.157 7.1a34.903 34.903 0 01-5.157.377 34.903 34.903 0 01-5.157-.377c1.2-4.438 3.22-7.1 5.157-7.1zm0 8.972a36.322 36.322 0 005.505-.413c.452 2.202.695 4.443.725 6.693H22.27c.03-2.25.273-4.491.725-6.693 1.823.277 3.663.415 5.505.413zm15.5 6.28h-7.82a36.958 36.958 0 00-.754-6.95 22.61 22.61 0 005.54-1.794A16.222 16.222 0 0144 28.252zm-7.82 1.496H44a16.224 16.224 0 01-3.034 8.768 22.61 22.61 0 00-5.54-1.794 36.96 36.96 0 00.754-6.974zm3.84-11.454a22.196 22.196 0 01-4.936 1.555 16.359 16.359 0 00-3.028-6.4 15.4 15.4 0 017.965 4.845zm-15.076-4.845a16.359 16.359 0 00-3.028 6.4 22.196 22.196 0 01-4.937-1.555 15.4 15.4 0 017.965-4.845zm-7.965 26.258a22.196 22.196 0 014.937-1.556 16.359 16.359 0 003.028 6.4 15.4 15.4 0 01-7.965-4.845zm15.083 4.862a16.362 16.362 0 003.022-6.418c1.697.323 3.354.845 4.937 1.555a15.4 15.4 0 01-7.965 4.845l.006.018z"
            ></path>
        </svg>
    );
}

export default SpeakSeveralLanguagesIcon;
